import { Box, Step, StepLabel, Stepper } from '@mui/material'
import { Supplier } from 'api/supplier/suppliers.types'
import { FC, useState } from 'react'
import { useSelector } from 'react-redux'
import CredentialEntry from './steps/CredentialEntry'
import CredentialValidation from './steps/CredentialValidation'
import VehicleList from './steps/VehicleList'
import VehicleMapping from './steps/VehicleMapping'

export interface IntegrationWizardData {
  supplierGroupId?: number
  endpoint?: string
  apiKey?: string
  appKey?: string
  appSecret?: string
  accountNumber?: string
  unmanagedAccountNumber?: string
  dispatchReference?: string
  isExistingConfig?: boolean
  previousSupplierGroupId?: number
}

const STEPS = ['Enter Credentials', 'Validate', 'Vehicles', 'Vehicle Mapping']

interface IntegrationSetupProps {
  initialStep?: number
  initialWizardData?: IntegrationWizardData
}

const IntegrationSetup: FC<IntegrationSetupProps> = ({
  initialStep = 0,
  initialWizardData,
}) => {
  const [activeStep, setActiveStep] = useState(initialStep)
  const [wizardData, setWizardData] = useState<IntegrationWizardData>(
    initialWizardData ?? {},
  )

  const supplier: Supplier = useSelector(
    (state: any) => state.suppliers.supplier,
  )
  if (supplier === null) return null

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
        {STEPS.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {activeStep === 0 && (
        <CredentialEntry
          supplier={supplier}
          initialValues={wizardData}
          onSubmit={(data) => {
            const trimmed = Object.fromEntries(
              Object.entries(data).map(([k, v]) => {
                if (typeof v !== 'string') return [k, v]
                const s = v.trim()
                return [k, k === 'endpoint' ? s.replace(/\/+$/, '') : s]
              }),
            )
            setWizardData(trimmed as IntegrationWizardData)
            setActiveStep(1)
          }}
        />
      )}

      {activeStep === 1 && (
        <CredentialValidation
          supplier={supplier}
          wizardData={wizardData}
          onSuccess={() => setActiveStep(2)}
          onBack={() => setActiveStep(0)}
        />
      )}

      {activeStep === 2 && (
        <VehicleList
          supplier={supplier}
          onBack={() => setActiveStep(0)}
          onProceed={() => setActiveStep(3)}
        />
      )}

      {activeStep === 3 && (
        <VehicleMapping
          supplier={supplier}
          onBack={() => setActiveStep(2)}
          onComplete={() => {
            window.location.reload()
          }}
          onCredentialError={() => setActiveStep(0)}
        />
      )}
    </Box>
  )
}

export default IntegrationSetup
